<template>
  <el-header
    class="border-bottom header bg-primary-dark text-white items-center flex"
  >
    <button
      :class="[
        'text-white hover:bg-primary-light w-10 h-10 flex items-center justify-center rounded-full bg-primary nav-toggle',
        { 'nav-toggle-on': navCollapse },
      ]"
      @click="toggleNavCollapse"
    >
      <svg
        class="fill-current w-6 h-6"
        focusable="false"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <g>
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
        </g>
      </svg>
    </button>
    <div class="ml-32">
      <h1 class="text-base ml-8 text-white">麦芽儿后台管理</h1>
    </div>
    <div class="flex-grow" />
    <router-link to="/" class="flex">
      <img class="h-12 object-contain logo mr-8" src="@/assets/maiya.jpg" />
    </router-link>
    <el-dropdown v-if="user" trigger="click" @command="handleMenuCommand">
      <span class="el-dropdown-link text-white">
        {{ user.username }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
        <el-dropdown-item command="logout">登出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- Password Change Dialog -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      @close="resetPasswordForm"
    >
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px"
      >
        <el-form-item label="当前密码" prop="currentPassword">
          <el-input
            v-model="passwordForm.currentPassword"
            type="password"
            show-password
            placeholder="请输入当前密码"
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            show-password
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            show-password
            placeholder="请确认新密码"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitPasswordChange"
          :loading="passwordLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </el-header>
</template>
<script>
import store from '@/store'
import api from '@/api'
import { mapState } from 'vuex'
export default {
  name: 'Header',
  props: {
    navCollapse: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      store,
      passwordDialogVisible: false,
      passwordLoading: false,
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      passwordRules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次密码输入不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['user']),
  },
  mounted() {
    api.profile().then(res => {
      this.$store.state.user = res.data
    })
  },
  methods: {
    toggleNavCollapse() {
      this.$emit('changeNavCollapse')
    },
    handleMenuCommand(command) {
      switch (command) {
        case 'changePassword':
          this.showPasswordDialog()
          break
        case 'logout':
          this.logout()
          break
        default:
          throw '没有该命令'
      }
    },
    showPasswordDialog() {
      this.passwordDialogVisible = true
    },
    resetPasswordForm() {
      this.passwordForm = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      }
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.clearValidate()
      }
    },
    submitPasswordChange() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.passwordLoading = true
          api
            .changePassword({
              current_password: this.passwordForm.currentPassword,
              new_password: this.passwordForm.newPassword,
            })
            .then(() => {
              this.$message.success('密码修改成功')
              this.passwordDialogVisible = false
              this.resetPasswordForm()
            })
            .catch(error => {
              this.$message.error(
                error.response?.data?.message || '密码修改失败'
              )
            })
            .finally(() => {
              this.passwordLoading = false
            })
        }
      })
    },
    logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    },
  },
}
</script>
<style lang="scss" scoped>
.nav-toggle {
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.nav-toggle-on {
  transform: rotate(-180deg);
}
.logo {
  border-radius: 12px;
  transition: transform 0.1s cubic-bezier(0, 1.8, 1, 1.8);
}
.logo:hover {
  transform: translateY(5px) rotate(-2deg) scale(1.15);
}
</style>
